import React, { useState } from "react";
import { Tabs } from "components/common";
import BalanceSubPage from "./balance/BalanceSubPage";
import TransferSubPage from "./transfer/TransferSubPage";
import LogSubPage from "./log/LogSubPage";
import CreateOrderSubPage from "./createOrder/CreateOrderSubPage";
import CreateUserSubPage from "./createUser/CreateUserSubPage";
import { Wrapper } from "./CreditWalletPage.styled";
import Google2FAModal from "components/common/modals/Google2FAModal";

const { TabPane } = Tabs;

export default function CreditWalletPage() {
  const [selectedTab, setSelecetedTab] = useState("Credit Wallet Balance");
  const [faModal, setFaModal] = useState(false);

  return (
    <Wrapper>
      <div className="main-container">
        <div className="subscriptions-tabs">
          <Tabs activeKey={selectedTab} onChange={(e) => setSelecetedTab(e)}>
            <TabPane
              tab={
                <span
                  className={
                    selectedTab == "Credit Wallet Balance"
                      ? "active-tab"
                      : "inactive-tab"
                  }
                >
                  Credit Wallet Balance
                </span>
              }
              key="Credit Wallet Balance"
            />

            <TabPane
              tab={
                <span
                  className={
                    selectedTab == "Transfer Credit"
                      ? "active-tab"
                      : "inactive-tab"
                  }
                >
                  Transfer Credit
                </span>
              }
              key="Transfer Credit"
            />
            <TabPane
              tab={
                <span
                  className={
                    selectedTab == "Create User" ? "active-tab" : "inactive-tab"
                  }
                >
                  Create User
                </span>
              }
              key="Create User"
            />
            <TabPane
              tab={
                <span
                  className={
                    selectedTab == "Create Order" ? "active-tab" : "inactive-tab"
                  }
                >
                  Create Order
                </span>
              }
              key="Create Order"
            />
            <TabPane
              tab={
                <span
                  className={
                    selectedTab == "Credit Log" ? "active-tab" : "inactive-tab"
                  }
                >
                  Credit Log
                </span>
              }
              key="Credit Log"
            />
          </Tabs>
        </div>
      </div>
      {selectedTab == "Credit Wallet Balance" && <BalanceSubPage />}
      {selectedTab == "Transfer Credit" && <TransferSubPage setSelecetedTab={setSelecetedTab} />}
      {selectedTab == "Credit Log" && <LogSubPage />}
      {selectedTab == "Create User" && <CreateUserSubPage setSelecetedTab={setSelecetedTab} />}
      {selectedTab == "Create Order" && <CreateOrderSubPage setSelecetedTab={setSelecetedTab} />}
      </Wrapper>
  );
}
